/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".integration-dialog kendo-dialog.k-dialog-wrapper .k-content{padding-bottom:.2rem}"];
export { styles as styles };
